module.exports = __webpack_public_path__ + "img/2897852.png";